import {H2, H3, PNoMargin} from '@/typography';
import {SectionPadding} from '@/section';
import Container from '@/container';
import {Row, Col} from '@/grid';
import {withBgNeutral100} from '@/hocs/withColors';
import {withUppercase} from '@/hocs/withFontType';
import {GridLayout, GridItem} from '@/ui/grid/grid-layout';
import BoxGrid from '@/ui/box-grid';
import {withMarginBottomDoubleXlToXl} from '@/hocs/withSpacing';
import PictureWrapper from '@/ui/images-wrapper';
import {withTextLeftToCenter} from '@/hocs/withAlignment';
import {useTranslations} from 'next-intl';
import {DivMargined, Grid, getSectionFeatures, workableAgentLink} from '@/content/features/shared';

const imgPath = '/static/images/features/ai-section/';

const Neutral100Section = withBgNeutral100(SectionPadding);
const RowMargined = withMarginBottomDoubleXlToXl(Row);
const H3Upper = withTextLeftToCenter(withUppercase(withMarginBottomDoubleXlToXl(H3)));

const AiSection = () => {
  const t = useTranslations('features.aiSection');

  const WorkableAgentFeaturesArray = getSectionFeatures(t, 'workableAgent');
  const CreatingContentFeaturesArray = getSectionFeatures(t, 'creatingContent');
  const SourcingAndMatchingFeaturesArray = getSectionFeatures(t, 'sourcingMatching');
  const AutomatingTasksFeaturesArray = getSectionFeatures(t, 'automatingTasks');

  return (
    <Neutral100Section>
      <Container>
        <Grid fluid>
          <RowMargined center="xs" start="lg" middle="xs">
            <Col xs={12} lg={4}>
              <H2>{t('title')}</H2>
            </Col>
            <Col xs={12} lg={8}>
              <PictureWrapper
                imgPath={imgPath}
                imageUrl="ai-section"
                imageTypeFallback="jpg"
                altImage={t('imageAlt')}
              />
            </Col>
          </RowMargined>

          <DivMargined>
            <H3Upper className="heading-4">{t('workableAgent.title')}</H3Upper>
            <GridLayout Col={3} lgCol={2} autoRows>
              {WorkableAgentFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="var(--purple100)">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3Upper className="heading-4">{t('creatingContent.title')}</H3Upper>
            <GridLayout Col={3} lgCol={2} autoRows>
              {CreatingContentFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="var(--purple100)">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3Upper className="heading-4">{t('sourcingMatching.title')}</H3Upper>
            <GridLayout Col={3} lgCol={2} autoRows>
              {SourcingAndMatchingFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="var(--purple100)">
                    <H3>{item.title}</H3>
                    <PNoMargin>
                      {item.richCopy
                        ? t.rich(`sourcingMatching.${item.richCopy}`, {link: workableAgentLink})
                        : item.copy}
                    </PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3Upper className="heading-4">{t('automatingTasks.title')}</H3Upper>
            <GridLayout Col={3} lgCol={2} autoRows>
              {AutomatingTasksFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="var(--purple100)">
                    <H3>{item.title}</H3>
                    <PNoMargin>
                      {item.richCopy
                        ? t.rich(`automatingTasks.${item.richCopy}`, {link: workableAgentLink})
                        : item.copy}
                    </PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>
        </Grid>
      </Container>
    </Neutral100Section>
  );
};

export default AiSection;
